import type { DiwassCredentials } from '@/types/nest/diwass'
import { computed, ref, type Ref } from 'vue'

export function useDiwassCredentialsValidation(credentials: Ref<DiwassCredentials | null>) {
  const submitted = ref(false)

  const errors = computed<Partial<Record<keyof DiwassCredentials, string>>>(() => {
    const data = credentials.value
    const result: Partial<Record<keyof DiwassCredentials, string>> = {}

    if (data?.username.trim().length === 0) {
      result.username = 'Gebruikersnaam is verplicht'
    }

    if (data?.webServiceClientId.trim().length === 0) {
      result.webServiceClientId = 'Web service client id is verplicht'
    }

    if (data?.id == null && data?.authenticationKey.trim().length === 0) {
      result.authenticationKey = 'Authenticatie sleutel is verplicht'
    }

    return result
  })

  const visibleErrors = computed<Partial<Record<keyof DiwassCredentials, string>>>(() => {
    if (!submitted.value) return {}
    return errors.value
  })

  const isValid = computed(() => Object.keys(errors.value).length === 0)
  const isSubmittedAndInvalid = computed(() => submitted.value && !isValid.value)

  function validate(): boolean {
    submitted.value = true
    return isValid.value
  }

  return { errors, visibleErrors, isValid, isSubmittedAndInvalid, submitted, validate }
}
